import { render } from "./Geraet.vue?vue&type=template&id=fb5b5764"
import script from "./Geraet.vue?vue&type=script&lang=js"
export * from "./Geraet.vue?vue&type=script&lang=js"

import "./Geraet.vue?vue&type=style&index=0&id=fb5b5764&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__